import { useMemo, useState } from 'react';
import type { FC, ReactNode } from 'react';
import { CreativeExpansionContext } from './CreativeExpansionContext';

export const CreativeExpansionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [expandedAll, setExpandedALl] = useState<boolean>(false);

  const memoizedContext = useMemo(() => {
    return { expandedAll, setExpandedALl };
  }, [expandedAll, setExpandedALl]);

  return <CreativeExpansionContext.Provider value={memoizedContext}>{children}</CreativeExpansionContext.Provider>;
};
